import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { Card } from './card';
import { TagType } from '@coworkrz/cards/types';

@Injectable({
  providedIn: 'root',
})
export class CardService {
  private http = inject(HttpClient);

  private url = 'cards';
  private cardNumberSubject$ = new BehaviorSubject<string | undefined>(
    undefined
  );
  private cardTagSubject$ = new BehaviorSubject<TagType | undefined>(undefined);
  private cardSubject$ = new BehaviorSubject<Partial<Card>>({});

  cardNumber$ = this.cardNumberSubject$.asObservable();
  cardTag$ = this.cardTagSubject$.asObservable();
  card$ = this.cardSubject$.asObservable();

  constructor() {
    this.subscribeToCard();
    this.subscribeToCardNumber();
  }

  getOne(id: string): Observable<Card> {
    return this.http.get<Card>(`${this.url}/${id}`);
  }

  setCardNumber(cardNumber?: string): void {
    const nextValue =
      cardNumber && cardNumber.trim().length >= 4 ? cardNumber : undefined;

    this.cardNumberSubject$.next(nextValue);
  }

  get card(): Partial<Card> {
    return {
      tag: this.cardTagSubject$.getValue(),
      number: this.cardNumberSubject$.getValue(),
    };
  }

  private subscribeToCard(): void {
    combineLatest([this.cardNumber$, this.cardTag$])
      .pipe(map(([number, tag]) => ({ number, tag })))
      .subscribe(this.cardSubject$);
  }

  private subscribeToCardNumber(): void {
    this.cardNumberSubject$
      .pipe(map((cardNumber) => this.determineTagType(cardNumber)))
      .subscribe(this.cardTagSubject$);
  }

  private determineTagType(cardNumber?: string): TagType | undefined {
    if (!cardNumber) return undefined;
    const visitorRegex = /^(000[1-9]|00[1-9]\d|0[1-9]\d{2}|09\d{2})$/;
    const memberRegex = /^\d{4,}$/;
    if (visitorRegex.test(cardNumber)) {
      return TagType.VISITOR;
    } else if (memberRegex.test(cardNumber)) {
      return TagType.MEMBER;
    }
    return undefined;
  }
}
